var render = function render(){var _vm=this,_c=_vm._self._c;return _c('Layout',[_c('div',[_c('PageHeader',{attrs:{"title":_vm.title,"items":_vm.items}}),_c('div',{staticClass:"row no-gutters"},[_c('div',{staticClass:"col-12"},[_c('Details')],1)])],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }